import { isValidTargetNode } from '@atlaskit/editor-common/selection/is-valid-target-node';
import { GapCursorSelection } from '@atlaskit/editor-common/selection/gap-cursor/selection';
import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';
import type { NextEditorPlugin } from '@atlaskit/editor-common/types/next-editor-plugin';
import { Selection, TextSelection } from '@atlaskit/editor-prosemirror/state';

export type PageTitleUtilsPlugin = NextEditorPlugin<
	'pageTitleUtils',
	{
		dependencies: [];
		commands: {
			selectDocStart: () => EditorCommand;
			insertNewLineAtDocStart: (text?: string) => EditorCommand;
		};
	}
>;

const selectDocStart =
	(): EditorCommand =>
	({ tr }) => {
		const docStartSelection = isValidTargetNode(tr.doc.firstChild)
			? new GapCursorSelection(tr.doc.resolve(0))
			: Selection.atStart(tr.doc);

		tr.setSelection(docStartSelection);

		return tr;
	};

const insertNewLineAtDocStart =
	(): EditorCommand =>
	({ tr }) => {
		const { paragraph, heading } = tr.doc.type.schema.nodes;
		const firstChild = tr.doc.firstChild;
		if (firstChild && [paragraph, heading].includes(firstChild.type) && !firstChild.childCount) {
			return selectDocStart()({ tr });
		}

		const emptyParagraph = tr.doc.type.schema.nodes.paragraph.create();
		tr.insert(0, emptyParagraph);
		tr.setSelection(TextSelection.near(tr.doc.resolve(0)));

		return tr;
	};

export const pageTitleUtilsPlugin: PageTitleUtilsPlugin = () => {
	return {
		name: 'pageTitleUtils',
		dependencies: [],
		commands: {
			selectDocStart,
			insertNewLineAtDocStart,
		},
	};
};
